/* tslint:disable:indent */
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BehaviorSubject, Observable} from 'rxjs';
import {FormsEnum} from 'src/app/models/enums/forms.enum';
import {CanNavigateInStepperService} from '../../../../shared/services/can-navigate-in-stepper.service';
import { FormulaireServiceService } from '../../../../formulaires/services/formulaire-service.service';


@Component({
  selector: 'app-form-step',
  templateUrl: './form-step.component.html',
  styleUrls: ['./form-step.component.scss'],
})
export class FormStepComponent implements OnInit,OnDestroy {

  public formsEnum = FormsEnum;
  @Input() indexPage: number;
  @Input() validationIndex: number;
  @Input() formulaireName: FormsEnum;
  @Input() disabled: boolean;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  @Input() form: FormGroup;
  @Input() nbDiffuseur: Observable<boolean>;
  // l'index du formulaire adapté
  @Input() fadIndex: number;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;

  constructor(
    private canNavigateInStepperService: CanNavigateInStepperService,
    private formulaireService: FormulaireServiceService
  ) {
  }

  ngOnDestroy(): void {
    this.formulaireService.actualFormIdAnnEmetteur.next(null);
    this.formulaireService.actualFormContractFolderId.next(null);
    this.formulaireService.idParentFluxBoampEform.next(null);
  }

  ngOnInit(): void {
  }


  public is(forms: FormsEnum): boolean {
    if (this.formulaireName && this.formulaireName.toString().includes('E_FORM') && FormsEnum[forms].toString().includes('E_FORM')) {
      return true;
    }
    return this.formulaireName && FormsEnum[forms] === this.formulaireName.toString();
  }

  getServiceNavigateDiffAD() {
    return this.canNavigateInStepperService.isSelectedDiffuseurADMoreThanZero;
  }
}
